import React from 'react';
import PropTypes from 'prop-types';

import styles from '../../styles/layouts/main.module.scss';
import PageMeta from '../partials/PageMeta';

const propTypes = {
    children: PropTypes.node.isRequired,
};

const defaultProps = {};

function MainLayout({ children }) {
    return (
        <div className={styles.container}>
            <PageMeta title='2P2L - Meilleurs voeux 2024' />
            <div className={styles.inner}>
                <div className={styles.content}>{children}</div>
            </div>
        </div>
    );
};

MainLayout.propTypes = propTypes;
MainLayout.defaultProps = defaultProps;

export default MainLayout;
